import { useNavigate } from "react-router-dom";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";
import ICONS from "../../../../assets/Icons";
import TaxationTransactionDetails from "../../../../containers/Transactions/TaxationTransactions/TaxationTransactionDetails";

const TaxTransactionDetailsPopup = ({
  transactionHeader,
  closePopup,
  tax_txn_id,
  typePopup,
  typeSingle,
}) => {
  const navigate = useNavigate();
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <LargePopupRedirect
        headerTitle={transactionHeader}
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        smallPopupHeader={"Are you sure you want to leave this page?"}
        headertextSize="font-md"
        isfullViewrequired={true}
        fullviewbtnText="Open in full view"
        fullviewbtnType="button"
        fullviewhandleFunction={() => {
          closePopup();
          navigate(
            `/tax_transaction_dashboard/view_all/view_details/${tax_txn_id}`,
          );
        }}
        fullviewisDisabled={false}
        fullviewenabledTextColor="var(--text-primary)"
        fullviewenabledBgColor="var(--primary-nav)"
        fullviewhoverOption="white"
        fullviewicon={ICONS?.REDIRECT}
        fullviewdisabledBgColor="var(--text-disabled)"
        closeiconbtnType="button"
        closeiconhandleFunction={closePopup}
        closeiconisDisabled={false}
        closeiconenabledBgColor="var(--primary-nav)"
        closeicondisabledBgColor="var(--text-disabled)"
        closeiconhoverOption="white"
        closeicon={ICONS?.CLOSE}
        isbottomSectionneed={false}
        bottomHeaderTextNeed={false}
        isscrollRequired={true}
      >
        <TaxationTransactionDetails
          tax_txn_id={tax_txn_id}
          closeBeneTxnDetailModal={closePopup}
          typePopup={typePopup}
          typeSingle={typeSingle}
        />
      </LargePopupRedirect>
    </div>
  );
};

export default TaxTransactionDetailsPopup;
